"use client";

import { CcDemoTabs } from "@/components/services/shared/CcDemoTabs";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";
import { devSectionAttr } from "@/lib/dev/section-attr";

import type { AiAutomationDemoCopy } from "./ai-automation-demo-copy";
import {
  AutoRepliesPhotoView,
  AutoRunsPhotoView,
  AutoTimePhotoView,
} from "./CcAutoValuePhotoViews";

type CcAutoValueProps = {
  copy: AiAutomationDemoCopy;
};

/**
 * "Värdet av AI-automation": three tabs following one made-up company (time
 * back → flows in operation → faster replies) as real photos with cards and
 * the real tools' logos. Same section layout and styles as the other demos.
 */
export function CcAutoValue({ copy }: CcAutoValueProps) {
  return (
    <section
      className="cc-section cc-seo-value"
      aria-labelledby="cc-auto-value-title"
      data-cc-nav="light"
      {...devSectionAttr("auto-value")}
    >
      <div className="cc-container">
        <header className="cc-seo-value__header">
          <CcSanjayaEyebrow theme="on-subtle">{copy.eyebrow}</CcSanjayaEyebrow>
          <h2 id="cc-auto-value-title" className="cc-seo-heading">
            {copy.title}
          </h2>
          <p className="cc-seo-lead cc-seo-value__lead">{copy.lead}</p>
        </header>

        <CcDemoTabs
          tablistLabel={copy.tablistLabel}
          disclaimer={copy.disclaimer}
          tabs={[
            {
              key: "time",
              label: copy.tabs.time,
              summary: copy.time.summary,
              content: <AutoTimePhotoView copy={copy.time} />,
            },
            {
              key: "runs",
              label: copy.tabs.runs,
              summary: copy.runs.summary,
              content: <AutoRunsPhotoView copy={copy.runs} />,
            },
            {
              key: "replies",
              label: copy.tabs.replies,
              summary: copy.replies.summary,
              content: <AutoRepliesPhotoView copy={copy.replies} />,
            },
          ]}
        />

        <p className="cc-seo-value__footnote">{copy.footnote}</p>
      </div>
    </section>
  );
}
